import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { publicApi, photoUrl } from "@/lib/account";
import { usePrefs } from "@/lib/prefs";

export default function Spotlight() {
  const [s, setS] = useState(null);
  const { t } = usePrefs();
  useEffect(() => { publicApi.get("/stories/spotlight").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20" data-testid="spotlight-section">
      <div className="card-royal rounded-3xl overflow-hidden grid md:grid-cols-2 bg-gradient-to-br from-[#2A1A10] to-[#181B26]">
        {s.photo ? <img src={photoUrl(s.photo)} alt={s.couple} className="w-full h-full min-h-[300px] object-cover" />
          : <div className="min-h-[300px] flex items-center justify-center"><Heart className="w-24 h-24 text-rose-400/40" fill="currentColor" /></div>}
        <div className="p-10 flex flex-col justify-center">
          <p className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold">{t("spotlight")}</p>
          <h2 className="font-display text-4xl font-semibold mt-3" data-testid="spotlight-couple">{s.couple}</h2>
          <p className="text-xs text-slate-400 mt-1">{[s.country, s.year && `${s.year}`].filter(Boolean).join(" · ")}</p>
          <p className="text-slate-300 mt-5 leading-relaxed line-clamp-6 italic">"{s.story}"</p>
          <Link to="/stories" className="text-amber-300 mt-6 flex items-center gap-2" data-testid="spotlight-read-more">{t("readStories")} <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    </section>
  );
}
